import { useInView } from '@/hooks/useInView';

const reviews = [
  { avatar: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/image-315.jpg', name: 'Arkhip', role: 'Student', text: 'I really like the classes. There is a computer, and you can program your robot, and then control it yourself.' },
  { avatar: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/image-317.jpg', name: 'Nina Mykolaivna', role: 'Lecturer of Computer Science', text: 'After classes with Nanit Robot, the children in the lessons do even more than I planned to give. They perform my tasks easily and are better oriented in the material.' },
  { avatar: 'https://storage.googleapis.com/storage.nanitrobot.com/wp-content/uploads/2023/07/image-316.jpg', name: 'Illya', role: 'Student', text: 'I like Nanit Robot. I learned Scratch with him.' },
];

export default function ReviewsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="reviews" ref={ref as React.RefObject<HTMLElement>} className="bg-white py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className={`text-center mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-block text-xs font-bold uppercase tracking-widest text-yellow-500 mb-3">Testimonials</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 font-syne">What people say</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              className={`bg-gray-50 rounded-2xl p-6 border border-gray-100 hover:border-yellow-300 transition-all duration-500 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0 border-2 border-yellow-400">
                  <img src={r.avatar} alt={r.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <h4 className="text-sm font-bold text-gray-900">{r.name}</h4>
                  <p className="text-xs text-gray-400">{r.role}</p>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {[...Array(5)].map((_, si) => (
                  <i key={si} className="ri-star-fill text-yellow-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">&ldquo;{r.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
